module.exports = __webpack_public_path__ + "img/help.fcab47c0.svg";